export enum ErrorMessagesInit {
    NO_SCRIPT_TAG = 'Cannot find script tag with searchready.bundle.js',
    NO_CONFIG_URL = 'Cannot find clientConfigURL parameter in script tag src attribute',
    NO_DYNAMIC_COMPONENT = 'Dynamic component was not found',
    INIT_GENERAL = 'Error while initializing application',
    NO_CONTAINER = 'Cannot find container element',
}

export enum ErrorMessagesNumberRangeFilter {
    INTEGER_FILTER_MIN_GREATER_MAX = 'Integer filter initial min value cannot be bigger than initial max value',
}
